const InventoryStats = [
  ["Task", "Hours per Day"],
  ["In Stock Items", 14],
  ["Out of Stock Items", 7],
  ["Low Stock Items", 3],
  ["Dead Stock Items", 1],
];
export default InventoryStats;
